/** Канонический адрес единственного Matrix-клиента портала. */
export const MESSENGER_PATH = '/messenger'

/** Учитывает прежние ссылки, которые роутер перенаправляет в основной клиент. */
export function isMessengerPath(pathname: string): boolean {
  return /\/(?:messenger(?:-fast)?|(?:apps\/)?chat-matrix(?:-fast)?|chat)(?:\/|$)/.test(pathname)
}
